export default "__VITE_ASSET__CATrPgn5__"